import { C as e } from "./useCollections-CUHBsxWQ.js";
import { Box as t, InputText as n, Text as r } from "@dixa/lib-shared-habla";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { useCallback as o, useContext as s } from "react";
import c from "classnames";
var l = {
	modalBody: "_modalBody_1ujd2_54",
	articleContainer: "_articleContainer_1ujd2_58",
	legacyArticleBackground: "_legacyArticleBackground_1ujd2_65",
	articleContent: "_articleContent_1ujd2_70",
	improveArticle: "_improveArticle_1ujd2_96",
	input: "_input_1ujd2_100"
};
// src/components/Modals/components/articleContentPreview.tsx
function u({ title: e, articleContent: n, className: o }) {
	return /* @__PURE__ */ a(t, {
		className: c(l.articleContainer, o),
		children: [e && /* @__PURE__ */ i(r.Heading, {
			variant: "heading-1",
			children: e
		}), /* @__PURE__ */ i(t, {
			className: l.articleContent,
			dangerouslySetInnerHTML: { __html: n }
		})]
	});
}
// src/components/Modals/components/improveArticleInput.tsx
function d({ value: e, onChange: o, onSubmit: s, isGenerating: u, isSaving: d, className: f }) {
	return /* @__PURE__ */ a(t, {
		className: c(l.improveArticle, f),
		children: [/* @__PURE__ */ i(r.Heading, {
			variant: "heading-2",
			children: "Improve article"
		}), /* @__PURE__ */ i(n, {
			className: l.input,
			onChange: (e) => o(e.target.value),
			onKeyDown: (t) => {
				if (t.key === "Enter") return s(e);
				if (t.key === "Escape") return o("");
			},
			value: e,
			disabled: u,
			placeholder: "Ask AI to edit or generate...",
			suffix: {
				type: "button",
				button: {
					icon: "enter",
					onClick: () => s(e),
					isLoading: u,
					disabled: d
				}
			}
		})]
	});
}
// ../utils/src/hooks/useNotification.ts
function f() {
	let t = s(e);
	return {
		errorNotify: o(({ title: e = "Something went wrong", text: n, ...r }) => {
			t({
				icon: "exclamation-circle-filled",
				time: 2e3,
				status: "danger",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: e,
				text: n
			});
		}, [t]),
		successNotify: o(({ title: e, text: n, ...r }) => {
			t({
				icon: "check-circle-filled",
				time: 3e3,
				status: "success",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: e,
				text: n
			});
		}, [t]),
		notify: t
	};
}
export { l as i, d as n, u as r, f as t };

//# sourceMappingURL=useNotification-BA0yx-Cj.js.map